import React, { CSSProperties } from 'react';
import { useThemeMode } from '@fabric-ui/theme';
import ReactJson from 'react-json-view';

export interface AvJsonViewerProps {
  data: Record<string, any>[] | Record<string, any>;
  style?: CSSProperties;
}

const AvJsonViewer: React.FC<AvJsonViewerProps> = ({ data, style }) => {
  const theme = useThemeMode();
  return (
    <ReactJson
      src={data}
      displayDataTypes={false}
      style={{ backgroundColor: 'transparent', ...style }}
      theme={theme === 'dark' ? 'bright' : undefined}
    />
  );
};

export { AvJsonViewer };
